import { fetchApi } from '@/config/axiosSetting.ts';
import {
  getIncidentCardDetailsInfoResponseType,
  getIncidentDetailsCardInfoPropsType,
} from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/getIncidentCardDetailsInfoProperty.types';

export const getIncidentDetailCardInfo = ({
  id,
}: getIncidentDetailsCardInfoPropsType): Promise<getIncidentCardDetailsInfoResponseType> => {
  return fetchApi({
    method: 'GET',
    url: `/property/reports/${id}/accident_information/`,
  });
};
